/*
 * Copyright (c) 2023-2025 Yesan SAS
 * All rights reserved
 *
 * The present software is the confidential and proprietary information of
 * Yesan SAS. You shall not disclose the present software and shall
 * use it only in accordance with the terms of the license agreement you
 * entered into with Yesan SAS. This software may be subject to
 * export or import laws in certain countries.
 */
/**
 * Translation
 */
export const translation = {
  "NotFound": "404 - Pagina non trovata",
  "ComingSoon": "Prossimamente",
  "YesanPersonalFinance": "Yesan, Finanza personale",
  "Yesan": "Yesan",
  "PersonalFinance": "Finanza personale",
  "YesanDownload": "Yesan Scaricare",
  "ThisWebsiteUsesCookies": "Utilizziamo i cookie per raccogliere e analizzare le informazioni sulle prestazioni e sull'utilizzo del nostro sito e per fornire funzioni di social media. Continuando, acconsentite all'utilizzo dei nostri",
  "IGotIt": "OK",
  "BecomeFinanciallyFree": "Diventa finanziariamente libero",
  "inStepsAndActions": "in 8 passi e 3 azioni.",
  "TrackPlanAnalyze": "Traccia. Pianificare. Analizzare.",
  "FTrack": "1. Tracciare",
  "FPlan": "2. Pianificare",
  "FAnalyze": "3. Analizzare",
  "Features": "Caratteristiche",
  "FeaturesSubHeading": "Per i principianti puri, per chi è già esperto di finanza, questa è l'applicazione di cui avete bisogno per diventare finanziariamente liberi.",
  "ManageAccounts": "Gestire i conti",
  "CashLiquidFixedAssetsLiabilities": "Contanti, liquidi, attività fisse e passività.",
  "TrackTransactions": "Traccia le transazioni",
  "IncomesExpensesTransferInvestments": "Entrate, spese, trasferimenti, investimenti.",
  "ImportExport": "Importazione / Esportazione",
  "YourDataAlwaysAccessible": "I vostri dati sempre accessibili.",
  "PlanYourFreedom": "Pianifica la tua libertà",
  "StepsAwayFromFI": "8 passi verso l'indipendenza finanziaria.",
  "BudgetsAndGoals": "Bilanci e obiettivi",
  "CheckYourProgressAndAchieve": "Controllate i vostri progressi e raggiungete i vostri obiettivi finanziari.",
  "DashboardAndAnalytics": "Cruscotto e analisi",
  "ReviewLearnOptimizeWith": "Esaminate, imparate, ottimizzate con grafici, approfondimenti e strumenti.",
  "Security": "Sicurezza",
  "MilitaryGradeEncryption": "Crittografia di livello militare, supporto della biometria, dati memorizzati sui vostri dispositivi.",
  "OfflineMode": "Modalità offline",
  "YourDataAlwaysAccessibleAndModif": "I vostri dati sono sempre accessibili e modificabili.",
  "Track": "Tracciamento",
  "Income": "Entrate",
  "Expense": "Spese",
  "Transfer": "Trasferimento",
  "transactionsAndManageAccounts": "e gestire una serie di conti:",
  "checkings": "Conto corrente",
  "savings": "Risparmio",
  "realEstate": "Immobili",
  "stocks": "Mercati azionari",
  "bonds": "Obbligazioni",
  "crypto": "Criptovalute",
  "notes": "Banconote, contanti Portafoglio",
  "envelopes": "Buste",
  "privateEquity": "Azioni private",
  "metal": "Metallo",
  "retirement": "Pensionamento",
  "lifeInsurance": "Assicurazione sulla vita",
  "intellectualProperty": "Proprietà intellettuale",
  "otherLiquidAsset": "Altre attività liquide",
  "otherFixedAsset": "Altre attività fisse",
  "mortgage": "Ipoteca",
  "loan": "Prestito al consumo",
  "creditCard": "Carta di credito",
  "otherLiability": "Altre passività",
  "AccountsManagement": "Gestione dei conti",
  "MultipleAccountsTypesAndGrouping": "Tipi di conti e raggruppamenti multipli",
  "LinkAccounts": "Collegamento dei conti dei vostri istituti (disponibile solo in alcuni Paesi)",
  "SmartAccounts": "Conti intelligenti",
  "AddEditDeleteTransactions": "Aggiungere / Modificare / Cancellare transazioni",
  "TickVerifiedTransactions": "Spuntare le transazioni verificate",
  "CategorizeTransactions": "Categorizzare le transazioni",
  "TagTransactions": "Etichettare le transazioni",
  "TrackKakeiboType": "Traccia il tipo di Kakeibo",
  "TrackInvestments": "Tracciare gli investimenti (disponibile solo in alcuni paesi)",
  "ImportFromCSVFile": "Importazione completa o incrementale di transazioni da file CSV",
  "ExportToCSVFile": "Esportazione delle transazioni in file CSV",
  "stepsTowardsFIPlanBudgetingReachGoals": "8 passi verso il piano di indipendenza finanziaria, budgeting dettagliato, per raggiungere più velocemente i vostri obiettivi finanziari.",
  "levelsTowardsFI": "8 livelli verso l'indipendenza finanziaria",
  "EstablishBudgetsPer": "Stabilire budget per",
  "account": "conto",
  "accountType": "tipo di conto",
  "KakeiboType": "Tipo di Kakeibo",
  "category": "categoria",
  "tag": "etichetta",
  "label": "etichetta",
  "TrackBudgetsPerFrequency": "Tenere traccia dei budget per frequenza",
  "CreateGoalsOnSpendingBalanceCashFlowActions": "Creare obiettivi su spesa, saldo, flusso di cassa, azioni",
  "TrackGoalsProgress": "Monitorare i progressi degli obiettivi",
  "ReviewLearnOptimizeWithReportsCharts": "Esaminare, imparare, ottimizzare con rapporti, grafici, tendenze, approfondimenti e strumenti.",
  "Dashboard": "Cruscotto",
  "FSNetWorth": "Rendiconto finanziario: Patrimonio netto",
  "FSPnL": "Rendiconto finanziario: Conto economico / Profitti e perdite",
  "FSBalanceSheetAssetsLiabilities": "Rendiconto finanziario: Stato patrimoniale, attività, passività",
  "FSCashFlow": "Rendiconto finanziario: Rendiconto finanziario, Debiti e Crediti, Flussi",
  "FSFlows": "Rendiconto finanziario: Flussi",
  "FSRatios": "Rendiconto finanziario: Rapporti",
  "TrendsMonthEnd": "Andamento di fine mese: Entrate e uscite, flusso di cassa",
  "TrendsPerformance": "Andamento della performance: YoY, MoM, WoW",
  "IncomeTrendsPer": "Andamento delle entrate per",
  "SpendingTrendsPer": "Andamento delle spese per",
  "RecurringItemsIE": "Voci ricorrenti: Entrate e uscite",
  "DebtProgressTrends": "Andamento del debito",
  "KakeiboMTDReviewTrends": "Kakeibo: Revisione MTD, ultimo mese, tendenze",
  "FIWCLE": "Indipendenza finanziaria: Grafico a parete, spese per energia vitale",
  "DebtPaydownSnowballAvalanche": "Riduzione del debito: Palla di neve, valanga",
  "FullyCustomizableAnalyticsRange": "Intervallo temporale di analisi completamente personalizzabile",
  "ContactUs": "Contattateci",
  "Privacy": "Privacy",
  "Terms": "Termini e condizioni",
  "About": "Informazioni su",
  "IAgreeToThe": "Accetto il",
  "AndThe": "e la",
  "PrivacyPolicy": "Informativa sulla privacy",
  "TermsOfUse": "Condizioni d'uso",

  "DigitalSoftwareExperienceTagline": "Esperienza software digitale per il mondo moderno",
  "DigitalExperience": "Esperienza digitale",
  "SoftwareForTheModernWorld": "Software per il mondo moderno",
  "MobileApplications": "Applicazioni mobili",
  "forConnectedAndOfflineHumans": "per gli esseri umani connessi e offline",
  "CloudSaaS": "Cloud SaaS",
  "ResponsiveAndWebServices": "Servizi web e responsive",
  "PersonalFinanceServices": "Servizi di finanza personale",
  "YS_p1": "Yesan è una società di software dinamica, specializzata nello sviluppo di applicazioni mobili all'avanguardia e su misura per i consumatori. Con una profonda comprensione delle esigenze e delle preferenze in evoluzione degli utenti tecnologici di oggi, Yesan si dedica alla creazione di esperienze mobili intuitive, coinvolgenti e ricche di funzionalità che arricchiscono la vita dei suoi utenti.",
  "YS_p2": "Al centro della missione di Yesan c'è un impegno incessante per l'innovazione e la creatività, ogni prodotto è realizzato meticolosamente per offrire funzionalità senza soluzione di continuità e un'esperienza utente eccezionale.",
  "PersonalFinanceApplication": "Applicazione di finanza personale",
  "YPF_p1": "Yesan, Personal Finance è un'applicazione mobile all'avanguardia per la finanza personale, progettata per fornire agli utenti strumenti completi di gestione finanziaria comodamente accessibili a portata di mano. Grazie a un'interfaccia elegante e intuitiva, Yesan, Personal Finance offre un approccio olistico alla gestione delle finanze, adatto a utenti con qualsiasi livello di alfabetizzazione finanziaria.",
  "YPF_p2": "Le caratteristiche principali includono il tracciamento del budget, la categorizzazione delle spese e il monitoraggio delle transazioni in tempo reale, consentendo agli utenti di ottenere informazioni sulle proprie abitudini di spesa senza alcuno sforzo. L'applicazione offre anche opzioni di budgeting personalizzabili, consentendo agli utenti di fissare obiettivi finanziari e di monitorare i loro progressi nel tempo.",
  "YPF_p3": "Inoltre, Yesan, Personal Finance dà priorità alla sicurezza, impiegando protocolli di crittografia all'avanguardia per salvaguardare le informazioni finanziarie sensibili degli utenti. Grazie a misure di sicurezza di livello bancario, gli utenti possono collegare con fiducia i loro conti e sincronizzare le transazioni senza compromettere la privacy.",
  "YPF_p4": "Yesan, Personal Finance va oltre il budgeting di base, offrendo analisi approfondite e raccomandazioni personalizzate per ottimizzare le decisioni finanziarie. Che si tratti di identificare potenziali opportunità di risparmio, monitorare i portafogli di investimento o gestire le strategie di rimborso del debito, l'applicazione fornisce approfondimenti su misura per aiutare gli utenti a raggiungere i propri obiettivi finanziari.",
  "Discover": "Scoprire",
  "Firstname": "Nome",
  "Lastname": "Cognome",
  "Company":"Azienda",
  "Subject": "Oggetto",
  "Email": "Email",
  "Message": "Messaggio",
  "ThankYouForContactingUs": "Grazie per averci contattato",
  "ValidFirstnameRequired": "È necessario un nome valido.",
  "ValidLastnameRequired": "È richiesto un cognome valido.",
  "ValidEmailAddressRequired": "Inserire un indirizzo e-mail valido.",
  "ValidSubjectRequired": "Selezionare un oggetto valido.",
  "ValidMessageRequired": "Inserire un messaggio valido.",
  "UnableToSendTheFormPleaseRetryLater": "Impossibile inviare il modulo, riprovare più tardi.",
  "Information": "Informazioni",
  "Sales":"Vendite",
  "Support": "Supporto",
  "Press": "Stampa",
  "Partnership": "Partnership",
  "Other": "Altro",
  "Blog":"Blog",

  "Accept":"Accettare",
  "Decline":"Rifiutare",

  "WorklogCalendar":"Calendario di lavoro per Jira",

  "DirectlyAccessibleInProjectApps":"Direttamente accessibile nelle app di progetto",
  "VisualizeWhereYouSpentYourTime":"Visualizzate dove avete trascorso il vostro tempo",
  "AllYourWorklogsInACalendar":"Tutti i vostri worklog in un calendario",
  "MonthSummary":"Riepilogo del mese",
  "CheckIfYouForgotToLogTime":"Controllare se si è dimenticato di registrare il tempo.",
  "DirectlyAccessTheIssuesAndUpdateTime":"Accesso diretto ai problemi e aggiornamento del tempo",
  "DirectlyAccessTheIssuesAndUpdateTimeDescription":"Fate clic sulla voce dell'agenda di lavoro per accedere direttamente alle questioni e modificare il tempo registrato.",
  "AlsoAvailableInDarkMode":"Disponibile anche in modalità scura",
  "DirectlyLogWorkOnTheCalendarVisually":"Registrare direttamente il lavoro sul calendario in modo visivo",
  "ClickOnTheCalendarToCreateNewWorklog":"Fare clic sul calendario per creare un nuovo registro di lavoro",

  "AppsForAtlassian":"Applicazioni per Atlassian",
  "YCL_p1":"Visualizzate tutti i vostri worklog su un calendario con viste mese, settimana, settimana lavorativa, giorno.",
  "YCL_p2":"Registrate il lavoro direttamente dal calendario selezionando visivamente la fascia oraria.",
  "YCL_p3":"Identificate se avete dimenticato di registrare il tempo per i vostri timesheet.",
  "YCL_p4":"Disponibile nella vostra lingua: Inglese (UK), Inglese (USA), Cinese (semplificato), Cinese (tradizionale), Ceco, Danese, Estone, Finlandese, Francese, Tedesco, Ungherese, Islandese, Italiano, Giapponese, Coreano, Norvegese, Polacco, Portoghese (Brasile), Portoghese (Portogallo), Russo, Spagnolo, Svedese, Turco.",

  "Kakeibo":"Kakeibo",
  "Genea":"Genea",
  "FinancialPortfolio":"Portafoglio finanziario per Jira",
  "BringRealFinancialPortfolio":"Porta la vera gestione del portafoglio finanziario su Jira. Tieni traccia di budget, CapEx/OpEx e costi di progetto in un unico posto.",
  "YFPAboutQ":"Quanto ci costano realmente i nostri progetti Jira?",
  "YFPAbout":"Portafoglio finanziario per Jira\nI responsabili finanziari e i PMO faticano a rispondere a una semplice domanda:\nQuanto ci costano realmente i nostri progetti Jira?\nJira tiene traccia del lavoro.\nLa finanza tiene traccia dei budget.\nQuesta app finalmente collega le due cose.\n\nFinancial Portfolio trasforma Jira in una piattaforma leggera di PPM + pianificazione finanziaria — senza bisogno di costosi strumenti aziendali.",
  "YFPPorfolioQ":"Bilanci e monitoraggio del portafoglio",
  "YFPPorfolioP":"Crea portafogli su più progetti Jira e definisci: importo del budget, valuta, intervallo di date, progetti inclusi, team. Tieni traccia dei costi effettivi automaticamente man mano che il lavoro viene svolto in Jira.",
  "YFPPorfolioListQ":"Portafogli",
  "YFPPorfolioListP":"Crea portafogli finanziari che combinano più progetti Jira e visualizza istantaneamente: budget vs costo effettivo, burn rate del progetto in tempo reale, ripartizione CapEx vs OpEx, costo per issue e progetto, report finanziari esportabili. Il tutto alimentato direttamente dai registri di lavoro di Jira.",
  "CostQ":"Calcolo automatico dei costi",
  "CostP":"Trasforma il monitoraggio del tempo in dati finanziari reali. L'app: legge i registri di lavoro di Jira, applica le tariffe orarie, calcola i costi reali del progetto su base giornaliera. Niente fogli di calcolo. Nessun lavoro manuale.",
  "RatesQ":"Tariffe",
  "RatesP":"Imposta la tariffa oraria per progetto, team o a livello globale",
  "ReportQ":"Reportistica finanziaria in formato CSV",
  "ReportP":"Esporta i dati finanziari del portafoglio in pochi secondi. Ideale per: team finanziari, reportistica CFO, pianificazione del budget, supporto alla revisione contabile",
  "SettingsQ":"Classificazione CapEx vs OpEx",
  "SettingsP":"Supporta i requisiti contabili e di revisione. Classifica il lavoro in: Sviluppo capitalizzabile (CapEx), Lavoro operativo (OpEx). Genera report esportabili pronti per i team finanziari."
};

export const documents = {
};
